import { render } from "./TotalsChart.vue?vue&type=template&id=4d54ef0d"
import script from "./TotalsChart.vue?vue&type=script&lang=ts"
export * from "./TotalsChart.vue?vue&type=script&lang=ts"
script.render = render

export default script